__turbopack_context__.v({
  "container": "BreadCrumb-module-scss-module__j5pqlW__container",
  "containerItem": "BreadCrumb-module-scss-module__j5pqlW__containerItem",
});
